import React from 'react';
import engrenagem from '../../assets/img/engrenagem.svg';
import "./style.css"

export default function Loading(props) {
    const {texto} = props;
    return(
        <div className="loading">
            <img src={engrenagem} alt='Loading'/>
            <p className="loading-texto dj-blink">Carregando...</p>
            <p className="loading-texto">{texto}</p>
        </div>
    )
}

export function LoadingV2(props) {
    const {texto} = props;

    return(
        <div className="loadingv2">
            <img src={engrenagem} alt='Loading' className="loadingv2-img"/>
            <div className="loadingv2-bloco-texto">
                <p className="loadingv2-texto dj-blink">Carregando...</p>
                <p className="loadingv2-texto">{texto}</p>
            </div>
        </div>
    )
}
